module.exports = __webpack_public_path__ + "img/015-captain.5507c822.png";